import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStackHorizontalAltFour32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconStackHorizontalAltFour32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 16a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m4.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M27 16a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStackHorizontalAltFour32);
